import React from "react";
import { ToastContainer } from "react-toastify";
import ManageAppSettings from "../components/AdminSettings/AppSettings/ManageAppSettings";

export const ManageAppSettingPage = () => {
  return (
    <div className="main-content">
      <div className="page-content">
        <div className="container-fluid">
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
          />
          <ManageAppSettings />
        </div>
      </div>
    </div>
  );
};
